export default function Card({ hero = false, className = '', children, ...rest }) {
  const cls = `aq-card ${hero ? 'aq-card--hero' : ''} ${className}`.trim();
  return (
    <div className={cls} {...rest}>
      {children}
    </div>
  );
}
